import { useMemo } from "react";
import PropTypes from "prop-types";

import { alignItems, hardwareSections, strCode } from "../../../consts";
import { t } from "../../../services";

import {
  DropdownInput,
  FlexContainers,
  PageSelector,
  SearchInput,
  SmallButton,
  SVG,
  WrapperContainer
} from "../../../components";
import { StoresButton } from "../../UserManagement/UsersTable/styled";
import { PageSelectorWrapper } from "./styled";

const HardwareControlOptions = ({
  hardwarePages,
  activePage,
  searchedText,
  viewOptions,
  selectedView,
  loading,
  setActivePage,
  setSearchedText,
  setSelectedView,
  setLocationsModalActive,
  onCreateNewHardware
}) => {
  const isMercury = useMemo(() => {
    return activePage === hardwareSections.MERCURY;
  }, [activePage]);

  return (
    <WrapperContainer
      Container={isMercury ? FlexContainers.FlexColumnStart : FlexContainers.FlexRowBetween}
      alignItems={alignItems.start}
      gap={16}
      width={"100%"}
      mb={16}>
      <PageSelectorWrapper>
        <PageSelector pages={hardwarePages} activePage={activePage} setActivePage={setActivePage} />
      </PageSelectorWrapper>

      <WrapperContainer
        Container={isMercury ? FlexContainers.FlexRowBetween : FlexContainers.FlexRowEnd}
        gap={8}
        width={"100%"}>
        <WrapperContainer Container={FlexContainers.FlexRow} gap={8}>
          <WrapperContainer width={340}>
            <SearchInput
              id="hardware-search"
              value={searchedText}
              setValue={setSearchedText}
              placeholder={t(strCode.SEARCH_PLACEHOLDER)}
            />
          </WrapperContainer>

          <WrapperContainer width={240}>
            <DropdownInput
              id="view-selector"
              placeholder={t(strCode.SELECT_PLACEHOLDER)}
              options={viewOptions}
              selectedOption={selectedView}
              onSelectOption={(id) => {
                setSelectedView(viewOptions.find((opt) => opt.id === id));
              }}
            />
          </WrapperContainer>
        </WrapperContainer>

        <WrapperContainer Container={FlexContainers.FlexRowStart} gap={8}>
          <WrapperContainer width={160}>
            <StoresButton secondary onClick={() => setLocationsModalActive(true)}>
              <SVG.LocationIcon />
              {t(strCode.LOCATIONS_TITLE)}
            </StoresButton>
          </WrapperContainer>

          {isMercury && (
            <SmallButton onClick={onCreateNewHardware} xShift={-64} disabled={loading}>
              {t(strCode.NEW_BTN)}
            </SmallButton>
          )}
        </WrapperContainer>
      </WrapperContainer>
    </WrapperContainer>
  );
};

HardwareControlOptions.propTypes = {
  hardwarePages: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      title: PropTypes.string.isRequired,
      disabled: PropTypes.bool.isRequired
    })
  ).isRequired,
  activePage: PropTypes.string.isRequired,
  searchedText: PropTypes.string.isRequired,
  viewOptions: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      value: PropTypes.string.isRequired
    })
  ).isRequired,
  selectedView: PropTypes.shape({
    id: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired
  }).isRequired,
  loading: PropTypes.bool.isRequired,
  setActivePage: PropTypes.func.isRequired,
  setSearchedText: PropTypes.func.isRequired,
  setSelectedView: PropTypes.func.isRequired,
  setLocationsModalActive: PropTypes.func.isRequired,
  onCreateNewHardware: PropTypes.func.isRequired
};

export default HardwareControlOptions;
